import { render } from "./AccountantForm.vue?vue&type=template&id=03beaf9a&scoped=true"
import script from "./AccountantForm.vue?vue&type=script&lang=js"
export * from "./AccountantForm.vue?vue&type=script&lang=js"

import "./AccountantForm.vue?vue&type=style&index=0&id=03beaf9a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03beaf9a"]])

export default __exports__